<vw-modal class="z-[9999]" [width]="'94%'" [height]="'auto'" [closeIcon]="'fas fa-times-circle'" [showCloseIcon]="true"
  [isOpen]="isOpen" (close)="close()" [customClasses]="'rounded-lg border shadow-xl'">
  <div modalHeader>
    <div class="w-full flex px-2 pt-2">
      <div class="flex w-full">
        <vw-circle-user-icon></vw-circle-user-icon>
        <div class="ml-2">
          <h2 class="text-primary-900 text-md font-semibold truncate pr-4">
            {{ 'common.modals.feedback.title' | translate }}
          </h2>
          <span class="text-[#7A8581] text-sm"> {{ 'common.modals.feedback.subtitle' | translate }}</span>
        </div>
      </div>
      <vw-close-btn (click)="close()"></vw-close-btn>
    </div>
  </div>

  <div modalBody>
    <div class="px-2 pb-2">
      @switch (feedbackType) {
      @case ('wdyt') {
      <div class="flex w-full pt-2 text-primary-900 mb-6">
        <vw-message-circle-question-icon class="h-6 w-6"></vw-message-circle-question-icon>
        <div class="ml-2">
          <h2 class="text-primary-900 text-md font-semibold truncate">
            {{ 'common.modals.feedback.wdyt.title' | translate }}
          </h2>
          <span class="text-[#7A8581] text-sm pt-2 ">
            {{ 'common.modals.feedback.wdyt.description' | translate }}
          </span>
          <vw-emoji-select class="flex pt-2 w-full" (selectedEmojiChange)="onEmojiSelected($event)"></vw-emoji-select>
        </div>
      </div>
      }
      }

      <!--message-->
      <div class="flex bg-gray-100 rounded-xl items-center justify-between px-4 mt-2">
        <input type="text"
          class="bg-transparent outline-none w-full placeholder:text-[#475569] placeholder:text-sm py-4 px-5"
          placeholder="{{ 'common.modals.ai-actions.content.message.placeholder' | translate }}" [(ngModel)]="message">
        <button class="bg-transparent rounded-full size-9 shrink-0 cursor-pointer flex items-center justify-center"
          (click)="onSendButtonClick()">
          <vw-icon-svg iconUrl="/assets/svg/send.svg" width="24px" height="24px"></vw-icon-svg>
        </button>
      </div>
    </div>
  </div>
</vw-modal>